import { APP_INITIALIZER } from '@angular/core';
import { FormMediator } from '@core/data-access/services/form/form-mediator.service';

export const provideFormMediator = () => ({
  provide: APP_INITIALIZER,
  useFactory: (formMediator: FormMediator) => () => formMediator,
  deps: [FormMediator],
  multi: true
});
